import { render } from "./DeliveryDuration.vue?vue&type=template&id=bc06187c&ts=true&lang=pug"
import script from "./DeliveryDuration.vue?vue&type=script&lang=ts"
export * from "./DeliveryDuration.vue?vue&type=script&lang=ts"

import "./DeliveryDuration.vue?vue&type=style&index=0&id=bc06187c&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__